import React from 'react';
interface ProgressBarProps {
  percentage: number;
  color: string;
  height?: string;
  className?: string;
}
export function ProgressBar({
  percentage,
  color,
  height = 'h-1.5',
  className = ''
}: ProgressBarProps) {
  return <div className={`w-full bg-gray-100 rounded-full overflow-hidden ${height} ${className}`} data-id="element-118">
      <div className="h-full rounded-full transition-all duration-500 ease-out" style={{
      width: `${percentage}%`,
      backgroundColor: color
    }} role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100} data-id="element-119" />
    </div>;
}